/** Same-origin relative path for the Microsoft OIDC `from` query. */
export function safeLoginFromPath(from: string | undefined): string | undefined {
  if (!from) {
    return undefined;
  }
  const trimmed = from.trim();
  if (!trimmed.startsWith('/') || trimmed.startsWith('//') || trimmed.startsWith('/\\')) {
    return undefined;
  }
  if (trimmed.includes('\\') || trimmed.includes('://') || /[\r\n\0]/.test(trimmed)) {
    return undefined;
  }
  return trimmed.slice(0, 512);
}

export function microsoftLoginHref(apiBaseUrl: string, from: string | undefined): string {
  const base = apiBaseUrl.replace(/\/$/, '');
  const path = `${base}/auth/microsoft`;
  const safe = safeLoginFromPath(from);
  if (!safe) {
    return path;
  }
  return `${path}?from=${encodeURIComponent(safe)}`;
}

export function ssoErrorMessage(error: string | null): string | null {
  if (error === 'sso') {
    return 'platform.auth.microsoft.failed';
  }
  if (error === 'sso_disabled') {
    return 'platform.auth.microsoft.unavailable';
  }
  return null;
}
